import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Reverse Psychology Marketing',
		description:
			'Tell customers NOT to vote for you. Watch votes mysteriously increase.'
	},
	{
		name: 'Subliminal Billboards',
		description:
			'Install billboards that flash messages too fast to see. Somehow still effective.'
	},
	{
		name: 'Dream Advertisement',
		description:
			'Broadcast marketing directly into customer dreams. Legal team still reviewing.'
	},
	{
		name: 'Quantum Brand State',
		description:
			"Your brand simultaneously exists and doesn't exist until observed."
	},
	{
		name: 'Retroactive Marketing',
		description: 'Launch campaigns that have already succeeded in the past.'
	},
	{
		name: 'Multiverse Branding',
		description:
			'Market to infinite parallel universes simultaneously. Infinite ROI potential!'
	},
	{
		name: 'Void Marketing Division',
		description:
			'Market directly to the void. The void is surprisingly brand-conscious.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Branding Group'],
	departments[DepartmentIds['Branding Group']].basePrice * 3,
	UpgradeIds.BrgExponent1
)

export default array
